import React, { useEffect, useState } from "react";
import { findIndex, get, lowerCase } from "lodash";
import { useStyles } from "./styles";
import userTickIcon from "./../../../assets/images/userTick.svg";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { Tooltip, Tab, Tabs, AppBar } from "@material-ui/core";
import { isEmpty } from "@aws-amplify/core";
import { useHistory } from "react-router";
import { USERS, TARGET, REPORTS } from "../../../constants/routeConstants";
import { IsNewValueState } from "Recoil/Checkins/atom";
import { useSetRecoilState } from "recoil";

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

const HorizontalTab = (props, tabIndex) => {
  const classes = useStyles();
  const [value, setValue] = useState(
    props.currentTabIndex ? props.currentTabIndex : 0
  );
  const [tabs, setTabs] = useState();
  const setIsNewValue = useSetRecoilState(IsNewValueState);

  const history = useHistory();
  useEffect(() => {
    setTabs(props.tabs);
    if (get(props, "selectedTab.key", "") && get(props, "pendoUrl")) {
      let index = 0;

      props.tabs.filter((res, idx) => {
        if (res.key === props.selectedTab.key) {
          index = idx;
        }
      });
      setValue(index);
    }
  }, [get(props, "selectedTab.key", ""), get(props, "tabs", [])]);

  const redirect = (tab) => {
    const location = history.location.pathname;
    if (location.includes(USERS)) {
      history.push(`${USERS}/${lowerCase(get(tab, "key"))}`);
    } else if (props.targetId) {
      history.push(`${TARGET}/${lowerCase(get(tab, "key"))}/${props.targetId}`);
    } else if (location.includes(TARGET)) {
      history.push(`${TARGET}/${lowerCase(get(tab, "key"))}`);
    } else if (location.includes(REPORTS)) {
      history.push(`${REPORTS}/${lowerCase(get(tab, "key"))}`);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setIsNewValue(true);
    const tab = get(props, `tabs.${newValue}`, {});
    if (props.setSelectedTab) {
      props.initializeTargetList &&
        props.initializeTargetList(tab, props.variables);
      props.setSelectedTab(tab);
    }
    if (get(props, "pendoUrl", false)) {
      redirect(tab);
    }
  };

  useEffect(() => {
    if (!isEmpty(props.selectedFilter)) {
      if (props.selectedFilter.gridName === "Target_TargetList") {
        setValue(
          props?.tabs?.findIndex((res) => res?.id === props?.selectedFilter?.id)
        );
      } else {
        setValue(findIndex(props.tabs, props.selectedFilter));
      }
    }
  }, [props.selectedFilter, props.tabs]);

  const getLabel = (tab, index) => {
    const res = props?.isNewData?.find(
      (result) => result?.isNew && tab?.key === result?.name
    );
    return (
      <span className="d-flex position-relative" mb={3}>
        {tab.text ? (
          <span className={`${classes.tabName} truncate-txt tab-name`}>
            {tab.text}
          </span>
        ) : (
          ""
        )}
        {res?.isNew && <span className={classes.dotIndicator}>&nbsp;</span>}
        {tab.subtext ? <span>{tab.subtext}</span> : ""}
        {tab.icon ? (
          <div
          // dangerouslySetInnerHTML={{
          //   __html: tab.icon,
          // }}
          >
            {tab.icon}
          </div>
        ) : (
          ""
        )}
        {tab.showCompleteIcon && props.showCount && tab.count === 0 ? (
          <span className={classes.tabsBadge}>
            <img className={classes.tabsIcon} src={userTickIcon} />
          </span>
        ) : (
          ""
        )}
        {props.showCount && !tab.showCompleteIcon ? (
          <span className={classes.tabsBadge}>{`${tab.count}`}</span>
        ) : (
          ""
        )}
        {tab.isDelete && !tab.isDefault && (
          <span className={classes.deleteTabBtn} onClick={props.deleteTab}>
            <CloseOutlinedIcon fontSize="small" />
          </span>
        )}
      </span>
    );
  };

  return (
    <div className={`${classes.root} horizontal-tab`}>
      <AppBar
        position="static"
        className={props.className ? props.className : classes.tabHeader}
        color="transparent"
        role="navigation"
        aria-label={props.ariaLabel}
      >
        <Tabs
          data-testid="tabs"
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="simple tabs example"
        >
          {(tabs || []).map((tab, index) => {
            const icon = props.tabIcons ? (
              <img src={props.tabIcons[index]} className={classes.tabIcon} />
            ) : (
              ""
            );
            return (
              <Tooltip title={get(tab, "text", "")}>
                <Tab
                  key={index}
                  label={getLabel(tab, index)}
                  {...a11yProps(index)}
                  icon={icon}
                  tabIndex={tabIndex}
                />
              </Tooltip>
            );
          })}
        </Tabs>
      </AppBar>
      {props.getTabContents && props.getTabContents(value)}
    </div>
  );
};

export default HorizontalTab;
